import { Route } from 'vue-router'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { checkNoRequiresAuthURL } from '../helpers/routes'

export const alertsGuard = (to: Route, _from: Route, next: any): void => {
  const isMobileUser = store.getters[`${ModuleNamespaces.AUTH}/getIsMobileUser`]
  if (isMobileUser) {
    return next()
  }
  const isPortalUser = store.getters[`${ModuleNamespaces.AUTH}/getIsPortalUser`]
  const isFactureUser = store.getters[`${ModuleNamespaces.AUTH}/getIsFactureUser`]
  const userIsAuthenticated = store.getters[`${ModuleNamespaces.AUTH}/userIsAuthenticated`]
  const isBlackList = checkNoRequiresAuthURL(to.name ?? '')
  if (userIsAuthenticated && !isPortalUser && !isBlackList && !isFactureUser) {
    store.dispatch(`${ModuleNamespaces.ALERTS_MESSAGES}/checkAlertsMessages`)
  }
  return next()
}
